import {LAYOUT_DELETE, LAYOUT_UPDATE, LAYOUT_INSERT} from '../actions/layoutDbActions'
import {combineReducers} from 'redux'
import { default as itemReducer } from './itemReducer'

export default combineReducers({
  delete: itemReducer(LAYOUT_DELETE),
  update: itemReducer(LAYOUT_UPDATE),
  insert: itemReducer(LAYOUT_INSERT)
})
